import React from 'react'
import Hero from './components/Hero'
import Benefits from './components/Benefits'
import SecurityNote from './components/SecurityNote'
import Pricing from './components/Pricing'
import Footer from './components/Footer'

function App() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="min-h-screen bg-white">
      <Hero onCTAClick={scrollToPricing} />
      <Benefits />
      <Pricing />
      <Footer />
    </div>
  )
}

export default App